// extracted by mini-css-extract-plugin
export default {"rocketsContainer":"Rockets_rocketsContainer__9XG9o"};